import api from './api';

export const getLocations = (params) => api.get('/v1/locations', { params });
export const getLocation = (id) => api.get(`/v1/locations/${id}`);
export const createLocation = (data) => api.post('/v1/locations', data);
export const updateLocation = (id, data) => api.put(`/v1/locations/${id}`, data);
export const deleteLocation = (id) => api.delete(`/v1/locations/${id}`);
export const batchDeleteLocations = (ids) => api.post('/v1/locations/batch-delete', { ids });
export const getLocationEmployees = (id, params) => api.get(`/v1/locations/${id}/employees`, { params });
